<template>
  <!-- 提单确认管理 -->
  <div class="page-container-manage page-container-booking" id="container">
    <el-form
      ref="searchFromRef"
      class="form-panel"
      label-position="top"
      :rules="searchDataFormRule"
      :model="searchData"
    >
      <el-row class="content-panel manage-content-panel">
         <el-row style="background-color:#fff; padding:10px 10px 0 10px; border-radius: 10px;">
        <!-- 查询-start -->
        <el-row :gutter="10">
          <el-col :span="10">
            <el-form-item>
              <el-input
                size="small"
                placeholder="请输入单个或多个客户业务编号、订单号、提单号进行查询，多个单号用分号隔开"
                clearable
                v-model="no"
                :title="no"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-top: 2px">
            <el-row>
              <el-button class="el-button-search" type="primary" size="small" plain @click="queryForm"
              >查询
              </el-button
              >
              <el-button type="primary" size="small" plain @click="resetForm"
              >重置
              </el-button
              >
              <el-button
               class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="!moreInfoVisible ? 'hidden' : ''"
              >显示高级查询
               <svg-icon icon-class="arrow-down" class="svg-change-color"></svg-icon>
              </el-button>
              <el-button
              class="advanced-query-btn"
                type="primary"
                size="small"
                plain
                @click="changMoreInfoVisible"
                v-if="moreInfoVisible ? 'hidden' : ''"
              >隐藏高级查询
              <svg-icon icon-class="arrow-up" class="svg-change-color"></svg-icon>
              </el-button>
            </el-row>
          </el-col>
        </el-row>
        <!-- 查询-end -->

        <!-- 高级查询-start -->
        <el-row
          class="content-panel title-fix advanced-query"
          v-show="moreInfoVisible"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="船公司:">
                <el-associate
                  :title="searchData.carrierName"
                  style="width: 100%"
                  :columns="associate_columns_carrier"
                  :query-method="associate_queryMethod_carrier"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="custNameCn"
                  value-prop="custAlias"
                  placeholder=""
                  @change="onChangeCarrier"
                  v-model="searchData.carrierName"
                  size="mini"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="16">
                  <el-form-item label="船名/航次:">
                    <el-associate
                      ref="vesselAssociate"
                      style="width: 100%"
                      :columns="associate_columns_vessel"
                      :query-method="associate_queryMethod_vessel"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="vesselName"
                      value-prop="vesselId"
                      placeholder=""
                      v-model="searchData.vesselName"
                      :title="searchData.vesselName"
                      size="mini"
                      name="vesselName"
                      @change="onChangeVessel"
                      case="upper"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <label slot="label" class="label_no"></label>
                    <el-input
                      size="mini"
                      placeholder=""
                      clearable
                      v-model="searchData.voyage"
                      :title="searchData.voyage"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="创建日期从/到:">
                    <el-date-picker
                      v-model="searchData.startCreateTime"
                      title="点击选择创建日期开始时间"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      date-format="YYYY-MM-DD HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no"></label>
                    <el-date-picker
                      v-model="searchData.endCreateTime"
                      title="点击选择创建日期截止时间"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      date-format="YYYY-MM-DD HH:mm:ss"
                      @change="changeEndCreateTime"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="大船开航日期从/到:">
                    <el-date-picker
                      v-model="searchData.startEtd"
                      title="点击选择大船开航日期开始时间"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      date-format="YYYY-MM-DD HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="">
                    <label slot="label" class="label_no"></label>
                    <el-date-picker
                      v-model="searchData.endEtd"
                      title="点击选择大船开航日期截止时间"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      date-format="YYYY-MM-DD HH:mm:ss"
                      @change="changeEndEtd"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item label="装货港:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_po"
                  :query-method="associate_queryMethod_po"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="portNameEn"
                  value-prop="mdPortId"
                  placeholder=""
                  @change="onPolChange"
                  v-model="searchData.polId"
                  :title="searchData.polName"
                  size="mini"
                  name="polName"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="卸货港:">
                <el-associate
                  style="width: 100%"
                  :columns="associate_columns_po"
                  :query-method="associate_queryMethod_po"
                  class="input_length"
                  clearable
                  :query-length="0"
                  :default-first-option="true"
                  label-prop="portNameEn"
                  value-prop="mdPortId"
                  placeholder=""
                  @change="onPodChange"
                  v-model="searchData.podId"
                  :title="searchData.podName"
                  size="mini"
                  name="podName"
                  case="upper"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-top: 17px">
              <el-row
                type="flex"
                justify="end"
                align="middle"
                :gutter="10"
                class="el-row-margin"
              >
                <el-button
                  class="el-button-search"
                  type="primary"
                  size="small"
                  plain
                  @click="queryMoreForm"
                >查询
                </el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="resetForm('senior')"
                >重置
                </el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </el-row>
       </el-row>
        <!-- 高级查询-end -->
        <!-- 状态栏-start -->
        <el-row>
          <el-col class="tabsContainer tab-module">
            <el-tabs
              type="border-card"
              v-model="activeName"
              @tab-click="handleClick"
            >
              <el-tab-pane
                :label="'全部(' + count0 + ')'"
                name="all"
              ></el-tab-pane>
              <el-tab-pane
                v-for="(item, index) in ebBLPlanApprovalStatusList"
                :key="index"
                :name="item.value"
              >
                <span slot="label">{{item.name + '('}}<span :class="[item.count > 0? 'hasTabPane': '']">{{item.count}}</span><span>{{')'}}</span></span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <!-- 状态栏-end -->
        <!-- 按钮栏-start -->
        <el-row class="state-panel">
         <el-row style="background-color:#fff;padding:10px">
          <el-button type="primary" size="small" plain @click="edit"
          >编辑
          </el-button
          >
          <el-button type="primary" size="small" plain @click="uploadGuarantee"
          >上传保函
          </el-button
          >
          <el-button type="primary" size="small" plain @click="excel"
          >EXCEL导出
          </el-button
          >
          <el-button type="primary" size="small" plain @click="toStatushistory"
          >状态历史
          </el-button
          >
          <el-button type="primary" size="small" plain @click="toVGMEdit"
          >维护VGM
          </el-button
          >
          <upload-guarantee-up-box
            :upload-guarantee-visible.sync="uploadGuaranteeVisible"
            :eb-order-id="currentTableData.ebOrderId"
            :resultEbOrder = "resultEbOrder"
            ref="uploadGuaranteeUpBoxRef"
          />
        </el-row>
        <!-- 按钮栏-end -->
        <!-- 表格-start -->
        <el-row style="margin-top: 5px">
          <hot-table
            ref="tableRef"
            :data-source="tableDataSource"
            :settings="tableSettings"
            col-settings-key="ebOrder"
            @cellDblclick="clickBill"
            @dblclick="dbClickBill"
          >
            <hot-column
              :has-tip="true"
              data="ebOrderId"
              title="操作"
              width="120"
              :hidden="true"
            >
              <column-printing-renderer
                hot-renderer
                @clickModule="clickModule"
              ></column-printing-renderer>
            </hot-column>
            <hot-column
              :has-tip="true"
              data="mblNo"
              title="提单号"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="docStatus"
              title="提单确认状态"
              width="150"
              dictName="EB_BL_STATUS"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="approvalStatus"
              title="提交状态"
              width="150"
              dictName="EB_BL_SUB_STATUS"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="orderNo"
              title="订单号"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="custBizNo"
              title="客户业务编号"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="realVesselNameEn"
              title="船名"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="realVoyage"
              title="航次"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="carrierName"
              title="船公司"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="polName"
              title="装货港"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="podName"
              title="卸货港"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="placeOfDeliveryName"
              title="交货地"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="etd"
              date-format="YYYY-MM-DD"
              title="开航日期"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="creatorName"
              title="创建人"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="createTime"
              date-format="YYYY-MM-DD HH:mm:ss"
              title="创建时间"
              width="150"
            ></hot-column>
          </hot-table>
          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination
              :current-page="pageConfig.currentPage"
              :layout="pageConfig.layout"
              :page-size="pageConfig.pageSize"
              :page-sizes="pageConfig.pageSizes"
              :total="pageConfig.total"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
          <!-- 分页end -->
        </el-row>
        <!-- 表格-end -->
    </el-row>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ResizeObserver from "resize-observer-polyfill";
import { queryCarrierInfo, queryDictRows, queryPoInfo, queryVoyageInfo, } from "@/api/commonService";
import { getOrderdata} from "@/api/bookingRequest";
import {
  getBillManage,
  ladinBillManageListExport,
  queryEbOrder,
  queryManageMentList,
  queryMoreEbOrder,
} from "@/api/ladinBill";
import columnPrintingRenderer from "@/components/CustomRenderer/columnPrintingRenderer";
import columnLinkRenderer from "@/components/CustomRenderer/columnLinkRenderer";
import uploadGuaranteeUpBox from "@/views/lading-bill/UploadGuaranteeUpBox";
import { ___ } from '@/utils/daoService/DaoServiceClientES6Adapter'
import ebOrder from "@/api/ebOrder";
import {downloadExcel} from "@/utils/downloadExcel";
//const ebOrder = ds.QEbOrder.using(dsc);
export default {
  name: "ladingbillManagement",
  components: {
    columnPrintingRenderer,
    columnLinkRenderer,
    uploadGuaranteeUpBox,
  },
  data() {
    return {
      //查询条件
      no: "",
      //查询
      searchData: {
        carrierName: null,
        vesselName: null,
        voyage: null,
        startCreateTime: null,
        endCreateTime: null,
        startEtd: new Date(new Date(new Date(new Date().getTime() - 24 * 1000 * 3600 * 58).toLocaleDateString()).getTime()),
        endEtd: new Date(new Date(new Date(new Date().getTime() + 24 * 1000 * 3600 * 27).toLocaleDateString()).getTime() + 24 * 1000 * 3600 - 1),
        polName: null,
        podName: null
      },
      //显示高级查询
      moreInfoVisible: false,
      //tab状态栏
      activeName: "all",
      //各订单状态数量
      count0: 0,
      //保函上传弹出框状态
      uploadGuaranteeVisible: false,
      resultEbOrder: {},
      // 表格数据
      tableDataSource: [],
      //当前行数据
      currentTableData: {},
      // 表格设置
      tableSettings: {
        height: 320,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      ebBLPlanApprovalStatusAllList: [],
      //提单状态列表
      ebBLPlanApprovalStatusList: [],
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 100,
        pagerCount: 100,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // 船公司联想控件
      associate_columns_carrier: [
        {
          title: "中文简称",
          field: "custAlias",
        },
        {
          title: "中文全称",
          field: "custNameCn",
        },
        {
          title: "助记码",
          field: "mnemonicCode",
        },
      ],
      // 船名联想控件
      associate_columns_vessel: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
      ],
      // 航次联想控件
      associate_columns_voyage: [
        {
          title: "船名",
          field: "vesselName",
        },
        {
          title: "航次",
          field: "voyage",
        },
        {
          title: "航次代码",
          field: "voyageCode",
        },
      ],
      // 装/卸货港联想控件
      associate_columns_po: [
        {
          title: "英文名称",
          field: "portNameEn",
        },
        {
          title: "中文名称",
          field: "portNameCn",
        },
        {
          title: "国家代码",
          field: "countryCode",
        },
        {
          title: "海港代码",
          field: "portCode",
        },
      ],
      searchDataFormRule: {
        startTime: [
          {
            validator: (rule, value, callback) => {
              const searchData = this.searchData;
              if (
                this.moreInfoVisible &&
                searchData.startTime &&
                searchData.endTime &&
                searchData.endTime < searchData.startTime
              ) {
                callback(new Error("开始时间不能大于结束时间"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        endTime: [
          {
            validator: (rule, value, callback) => {
              console.log(rule);
              const searchData = this.searchData;
              if (
                this.moreInfoVisible &&
                searchData.startTime &&
                searchData.endTime
              ) {
                const startTime = new Date(searchData.startTime);
                const endTime = new Date(searchData.endTime);
                if (endTime.getTime() <= startTime.getTime()) {
                  callback(new Error("开始时间不能大于结束时间"));
                }
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      //日期设置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  async created() {
    // this.queryForm()

    this.setDictionaries();
    this.setDocStatusDictionaries();
    this.searchData.startEtd = new Date().setMonth(new Date().getMonth() - 2);
    this.searchData.endEtd = new Date().setMonth(new Date().getMonth() + 1);
  },
  activated() {
    setTimeout(() => {
      this.$nextTick (() => {
        this.$refs.tableRef.render()
      })
    },100);
  },
  mounted() {
    if (this.$route.params.fromWhere === "afterSubmit"){
      this.queryMoreForm() ;
    }
    this.tableSettings.height = document.body.clientHeight - 100 -150;
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
  methods: {
    onPolChange(value,selectedRows){
      this.searchData.polId = selectedRows.mdPortId;
      this.searchData.polName = selectedRows.portNameEn;
    },
    onPodChange(value,selectedRows){
      this.searchData.podId = selectedRows.mdPortId;
      this.searchData.podName = selectedRows.portNameEn;
    },
    onChangeCarrier(value,selectedRows){
      this.searchData.csCustId = selectedRows.csCustId;
    },
    onChangeVessel() {
      let record = this.$refs.vesselAssociate.list[this.$refs.vesselAssociate.hoverIndex];
      this.searchData.vesselName = record.vesselName;
      this.searchData.voyage = record.voyage;
      this.searchData.vesselId = record.vesselId;
    },
    changeEndEtd() {
       let self = this;
      self.searchData.endEtd = new Date(self.searchData.endEtd.getTime() + 1000 * 24 * 3600 - 100)
    },
    changeEndCreateTime() {
       let self = this;
      self.searchData.endCreateTime = new Date(self.searchData.endCreateTime.getTime() + 1000 * 24 * 3600 - 100)
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          custType4: "%SO%",
          isDeleted6: "0",
        };
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPCsCust.custNameCn"],
        mainModelName: "CTS_ILPCsCust",
        tag: "CTS_WEB_es",
        where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPCsCust.csCustId",
          "CTS_ILPCsCust.custAlias",
          "CTS_ILPCsCust.custNameCn",
          "CTS_ILPCsCust.custNameEn",
          "CTS_ILPCsCust.customsRegisteredNo",
          "CTS_ILPCsCust.esCustType",
          "CTS_ILPCsCust.isActive",
          "CTS_ILPCsCust.isBlacklist",
          "CTS_ILPCsCust.isCustomer",
          "CTS_ILPCsCust.isDeleted",
          "CTS_ILPCsCust.isOneTimeCustomer",
          "CTS_ILPCsCust.isSettlement",
          "CTS_ILPCsCust.isSupplier",
          "CTS_ILPCsCust.legalPerson",
          "CTS_ILPCsCust.mdmCustCode",
          "CTS_ILPCsCust.mobileNo",
          "CTS_ILPCsCust.postCode"
        ],
        enableCascade: true
      };
      return new Promise((resolve) => {
        queryCarrierInfo(data).then((res) => {
          console.log("queryCarrierInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({keyword, pageSize, currentPage}) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
        };
      } else {
        params = {
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.vesselName"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.voyage LIKE :voyage1 OR CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0)) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted2)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
        };
      } else {
        params = {
          isDeleted3: "0",
          vesselName0: "%" + keyword + "%",
          voyage1: "%" + keyword + "%",
          voyageCode2: "%" + keyword + "%",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVoyagePlan.voyage"],
        mainModelName: "CTS_ILPMdVoyagePlan",
        tag: "CTS_ILP_es",
        where:
          "(((CTS_ILPMdVoyagePlan.vesselName LIKE :vesselName0 OR CTS_ILPMdVoyagePlan.voyage LIKE :voyage1) OR CTS_ILPMdVoyagePlan.voyageCode LIKE :voyageCode2) AND CTS_ILPMdVoyagePlan.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdVoyagePlan.mdVoyagePlanId",
          "CTS_ILPMdVoyagePlan.createTime",
          "CTS_ILPMdVoyagePlan.principalGroupCode",
          "CTS_ILPMdVoyagePlan.customsVesselName",
          "CTS_ILPMdVoyagePlan.lastModifyTime",
          "CTS_ILPMdVoyagePlan.isDeleted",
          "CTS_ILPMdVoyagePlan.remark",
          "CTS_ILPMdVoyagePlan.recordVersion",
          "CTS_ILPMdVoyagePlan.voyage",
          "CTS_ILPMdVoyagePlan.voyageCode",
          "CTS_ILPMdVoyagePlan.createOffice",
          "CTS_ILPMdVoyagePlan.customsVoyage",
          "CTS_ILPMdVoyagePlan.vesselId",
          "CTS_ILPMdVoyagePlan.appCode",
          "CTS_ILPMdVoyagePlan.createOfficeName",
          "CTS_ILPMdVoyagePlan.creatorName",
          "CTS_ILPMdVoyagePlan.creatorId",
          "CTS_ILPMdVoyagePlan.customsVesselId",
          "CTS_ILPMdVoyagePlan.lastModifyOfficeName",
          "CTS_ILPMdVoyagePlan.lastModifyOffice",
          "CTS_ILPMdVoyagePlan.lastModifierName",
          "CTS_ILPMdVoyagePlan.ioFlag",
          "CTS_ILPMdVoyagePlan.carrierId",
          "CTS_ILPMdVoyagePlan.lastModifierId",
          "CTS_ILPMdVoyagePlan.vesselName",
          "CTS_ILPMdVoyagePlan.carrierName",
        ],
        enableCascade: true,
      };

      return new Promise((resolve) => {
        queryVoyageInfo(data).then((res) => {
          console.log("queryVoyageInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    // 装/卸货港联想控件数据源
    associate_queryMethod_po({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      } else {
        params = {
          portNameEn0: "%" + keyword + "%",
          portNameCn1: "%" + keyword + "%",
          countryCode2: "%" + keyword + "%",
          portCode3: "%" + keyword + "%",
          portType4: ["OP", "IP"],
          isDeleted5: "0",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdPort.portNameEn"],
        mainModelName: "CTS_ILPMdPort",
        tag: "CTS_ILP_es",
        where:
          "(((((CTS_ILPMdPort.portNameEn LIKE :portNameEn0 OR CTS_ILPMdPort.portNameCn LIKE :portNameCn1) OR CTS_ILPMdPort.countryCode LIKE :countryCode2) OR CTS_ILPMdPort.portCode LIKE :portCode3) AND CTS_ILPMdPort.portType IN( :portType4)) AND CTS_ILPMdPort.isDeleted = :isDeleted5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdPort.mdPortId",
          "CTS_ILPMdPort.createOffice",
          "CTS_ILPMdPort.lastModifyOffice",
          "CTS_ILPMdPort.lastModifyOfficeName",
          "CTS_ILPMdPort.lastModifierId",
          "CTS_ILPMdPort.areaCode",
          "CTS_ILPMdPort.lineNameCn",
          "CTS_ILPMdPort.portNameEn",
          "CTS_ILPMdPort.principalGroupCode",
          "CTS_ILPMdPort.customsCode",
          "CTS_ILPMdPort.isActive",
          "CTS_ILPMdPort.createOfficeName",
          "CTS_ILPMdPort.creatorName",
          "CTS_ILPMdPort.lastModifierName",
          "CTS_ILPMdPort.appCode",
          "CTS_ILPMdPort.longitude",
          "CTS_ILPMdPort.creatorId",
          "CTS_ILPMdPort.recordVersion",
          "CTS_ILPMdPort.lastModifyTime",
          "CTS_ILPMdPort.portNameCn",
          "CTS_ILPMdPort.portCode",
          "CTS_ILPMdPort.createTime",
          "CTS_ILPMdPort.isDeleted",
          "CTS_ILPMdPort.iataCode",
          "CTS_ILPMdPort.latitude",
          "CTS_ILPMdPort.lineId",
          "CTS_ILPMdPort.countryName",
          "CTS_ILPMdPort.countryCode",
          "CTS_ILPMdPort.portType",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPoInfo(data).then((res) => {
          console.log("res", res);
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //打印
    clickModule(value) {
    },
    //获取数据字典
    setDictionaries() {
      queryDictRows("MD_CODE_DICT$EB_BL_SUB_STATUS").then((res) => {
        let dict = [];
        res['MD_CODE_DICT$EB_BL_SUB_STATUS'].forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        this.ebBLPlanApprovalStatusList = dict;
        // 数据字典
        this.$hotTableUtils.registDict({ EB_BL_SUB_STATUS: dict });
      });
    },
    //获取提单确认状态数据字典
    setDocStatusDictionaries() {
      queryDictRows("MD_CODE_DICT$EB_BL_STATUS").then((res) => {
        let dict = [];
        res.MD_CODE_DICT$EB_BL_STATUS.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          dict.push(param);
        });
        // 数据字典
        this.$hotTableUtils.registDict({ EB_BL_STATUS: dict });
      });
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      this.pageConfig.pageSize = val;
      if (this.moreInfoVisible) {
        this.queryForm("senior");
      } else {
        this.queryForm();
      }
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val;
      if (this.moreInfoVisible) {
        this.queryForm("senior");
      } else {
        this.queryForm();
      }
    },
    // 单击行事件
    rowClick(val) {
      this.currentTableData = val.record;
    },
    // 双击行事件
    dbClick(val) {
      this.currentTableData = val.record;
    },
    changMoreInfoVisible() {
      this.moreInfoVisible = !this.moreInfoVisible
      if (this.moreInfoVisible) {
        this.tableSettings.height = this.tableSettings.height - 143
      }
      if(!this.moreInfoVisible) {
        this.tableSettings.height = this.tableSettings.height +143
      }
    },
    resetForm(type) {
      if (type === "senior") {
        this.searchData = {
          carrierName: null,
        vesselName: null,
        voyage: null,
        startCreateTime: null,
        endCreateTime: null,
        startEtd: new Date(new Date(new Date(new Date().getTime() - 24 * 1000 * 3600 * 60).toLocaleDateString()).getTime()),
        endEtd: new Date(new Date(new Date(new Date().getTime() + 24 * 1000 * 3600 * 31).toLocaleDateString()).getTime() + 24 * 1000 * 3600 - 1),
        polName: null,
        podName: null
        };
      } else {
        this.no = null;
      }
    },
    //简单查询
    queryForm() {
      let self = this;
      self.queryButton = 1;
      if (self.no.trim().length === 0) {
        //self.$coreMethods.message('warning', '请输入单个或多个委托号;提单号;运编号')
        self.queryMoreForm();
      } else {
        let queryData = {
          currentPage: self.pageConfig.currentPage,
          pageSize: self.pageConfig.pageSize,
          // orderStatus: self.activeName === "all" ? "" : self.activeName,
        };
        // self.queryAll();
        if (self.no.split(";").length > 1) {
          queryData.arrayNoList = self.no.split(";");
        } else {
          queryData.arrayNo = "%" + self.no + "%";
        }
        getBillManage(queryData).then((res) => {
          if (res.success) {
            self.tableDataSource = res.records.records;
            self.pageConfig.total = res.records.totalRecord;
            self.count0 = self.pageConfig.total = res.records.totalRecord;
            self.filterStatus(res.records.records);
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    //高级查询
    queryMoreForm() {
      let self = this;
      self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;
      self.queryButton = 2;
      let num = 0
      for (let s in self.searchData) {
        if (self.searchData[s] !== "") {
          num++
        }
      }
      if (num === 0) {
        self.$coreMethods.message('warning', '至少输入一个查询条件')
      } else {
        self.searchData.currentPage = self.pageConfig.currentPage;
        self.searchData.pageSize = self.pageConfig.pageSize;
        self.searchData.orderStatus = self.activeName === "all" ? "" : self.activeName;
        let oldEndCreateTime = "";
        if (self.searchData.endCreateTime !== null){
          oldEndCreateTime = self.searchData.endCreateTime;
          self.searchData.endCreateTime = new Date(self.searchData.endCreateTime.getTime() + 1000 * 24 * 3600 - 100);
        }
        getBillManage(self.searchData).then((res) => {
          //self.searchData.voyage = voyage;
          if (self.searchData.endCreateTime !== null){
            self.searchData.endCreateTime = oldEndCreateTime;
          }
          if (res.success) {
            self.tableDataSource = res.records.records;
            self.pageConfig.total = res.records.totalRecord;
            self.count0 = self.pageConfig.total = res.records.totalRecord;
            console.log(res.records.records)
            self.filterStatus(res.records.records);
            if (res.records.totalRecord === 0){
              self.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
            }else {
              self.$coreMethods.message("success", "查询成功！");
            }
          }
        });
      }
    },
    //简单查询所有
    queryAll() {
      let self = this;
      let allSearchData = {
        arrayNo: self.no.trim().split(";"),
        orderStatus: "",
      };
      ebOrder.queryEbOrder(allSearchData).then((res) => {
        console.log("queryEbOrder", res);
        if (res.success) {
          self.filterStatus(res.data);
        }
      });
    },
    //高级查询所有
    queryAllMore() {
      let self = this;
      let allSearchData = {
        carrierName: self.searchData.carrierName,
        vesselName: self.searchData.vesselName,
        voyage: self.searchData.voyage,
        startTime: self.searchData.createTime[0],
        endTime: self.searchData.createTime[1],
        polName: self.searchData.polName,
        podName: self.searchData.podName,
        orderStatus: "",
      };
      queryMoreEbOrder(allSearchData).then((res) => {
        console.log("queryMoreEbOrder", res);
        if (res.success) {
          console.log(res.records.records)
          self.filterStatus(res.records.records);
        }
      });
    },
    // tab切换事件
    handleClick(tab, event) {
      let self = this;
      if (tab.name === "all") {
        self.tableDataSource = self.ebBLPlanApprovalStatusAllList;
        return;
      }
      self.pageConfig.currentPage = 1;
      let target = self.ebBLPlanApprovalStatusList.find(
        (item) => item.value === tab.paneName
      );
      self.tableDataSource = target.filterList;
      self.pageConfig.total = target.count
    },
    //各提单状态数量
    filterStatus(data) {
      let self = this;
      self.ebBLPlanApprovalStatusAllList = JSON.parse(JSON.stringify(data));
      self.initStatus();
      self.count0 = data.length
      self.ebBLPlanApprovalStatusList.forEach((dictItem) => {
        let filterList = data.filter(
          (item) => dictItem.value === item.approvalStatus
        );
        dictItem.filterList = filterList;
        dictItem.count = filterList.length;
      });
      if (self.activeName !== 'all') {
        let targetStatus = self.ebBLPlanApprovalStatusList.find(item => item.value === self.activeName)
        self.tableDataSource = targetStatus.filterList
      }
    },
    initStatus() {
      let self = this;
      self.ebBLPlanApprovalStatusList.forEach(dictItem => {
        dictItem.count = 0
      })
    },
    //计算个状态数量
    calculationStatusCount() {
      const tableDataSource = this.tableDataSource;
      this.ebBLPlanApprovalStatusAllList.forEach((status) => {
        status.count = tableDataSource.filter((data) => {
          return data.approvalStatus === status.value;
        }).length;
      });
      let self = this
      let whereObj = null;
      const valueObj = {};

      whereObj = ebOrder.isDeleted.eq(___);
      valueObj.isDeleted = "0";
      whereObj = whereObj.and(ebOrder.orderStatus.eq(":orderStatus"));
      for (let value of this.ebBLPlanApprovalStatusAllList.values()) {
        valueObj.orderStatus = value.value;
        let searchData = {
          page: this.pageConfig.currentPage,
          limit: this.pageConfig.pageSize,
          no: this.no,
          whereObj: whereObj,
          valueObj: valueObj
        }
        queryManageMentList(searchData).then((res) => {
          if (res.success) {
            this.count0 = res.data.totalRecord;
          }
        });
      }
    },
    //过滤对象空值
    filterEmpty(searchData) {
      for (const key in searchData) {
        if (!searchData[key] && searchData[key] !== 0) {
          delete searchData[key];
        }
      }
    },
    //编辑
    edit() {
      let self = this;
      const params = self.$refs.tableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("waring", "请勾选记录");
        return;
      }
      if (params.length > 1) {
        self.$coreMethods.message("waring", "请勾选一条记录");
        return;
      }
      self.$router.push({
        name: "ladingbillEdit",
        params: {
          ebOrderId: params[0].ebOrderId,
          type: 'edit'
        },
      });
    },
    // 表格双击事件
    dbClickBill(val) {
      let self = this;
      let row = val.record;
      if (val.col === 1) {
        self.$router.push({
          name: "ladingbillEdit",
          params: {
            ebOrderId: row.ebOrderId,
            type: 'edit'
          },
        });
      }
    },
    //表格单击事件
    clickBill(val) {
      let self = this;
      let row = val.record;
      self.$router.push({
        name: "ladingbillEdit",
        params: {
          ebOrderId: row.ebOrderId,
          type: 'edit'
        },
      });
    },
    uploadGuarantee() {
      let self = this;
      let params = self.$refs.tableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        getOrderdata({ebOrderId: params[0].ebOrderId}).then(res => {
          console.info(res.records);
          let resultEbOrder = res.records;
          self.resultEbOrder = res.records;
          let serviceItems = [];
          resultEbOrder.ebServiceItems.forEach(item => {
            serviceItems.push(item.serviceCode);
          });
          if (params[0].orderStatus !== resultEbOrder.orderStatus) params[0].orderStatus = resultEbOrder.orderStatus;
          if (params[0].ebOrderStatus !== resultEbOrder.ebOrderStatus) params[0].ebOrderStatus = resultEbOrder.ebOrderStatus;
          if (resultEbOrder.orderStatus !== "CRM") return self.$coreMethods.message("warning", "请选择订单提交状态为已接受的记录！");
          if (resultEbOrder.ebOrderStatus === "UNLOAD") return self.$coreMethods.message("warning", "请选择订单状态不为以退关的记录！");
          self.uploadGuaranteeVisible = true;
          resultEbOrder.blPlanId = params[0].blPlanId;
          self.$refs.uploadGuaranteeUpBoxRef.setEbPlanId(resultEbOrder);
        });
      }
    },
    excel() {
      // if (this.moreInfoVisible) {
      //   let searchData = {
      //     page: this.pageConfig.currentPage,
      //     limit: this.pageConfig.pageSize,
      //     approvalStatus: self.activeName === "all" ? null : this.activeName,
      //     ...this.searchData,
      //   };
      //   this.filterEmpty(searchData);
      //   ladinBillManageListExport(searchData);
      // } else {
      //   let searchData = {
      //     page: this.pageConfig.currentPage,
      //     limit: this.pageConfig.pageSize,
      //     no: this.no,
      //     approvalStatus: this.activeName === "all" ? null : this.activeName,
      //   };
      //   this.filterEmpty(searchData);
      //   ladinBillManageListExport(searchData);
      // }
      var  selectData = []
      if(this.$refs.tableRef.getSelections().length>0){
        selectData = this.$refs.tableRef.getSelections()
      }else{
        if(this.tableDataSource.length>0){
          selectData = this.tableDataSource
        }
      }
      var  ebOrderIds = []
      for(var a in selectData){
        ebOrderIds.push(selectData[a].ebOrderId)
      }
      var tableCol =this.$refs.tableRef.$children
      var str =''
      for(var i=0; i<tableCol.length-2; i++){
        str+= tableCol[i].columnSettings.data
        if(i!==tableCol.length-3){
          str+=','
        }
      }
      //window.location.origin
      var url = process.env.VUE_APP_BASE_API+'/web/daoService/excelExport/custom-sql/cts-web/CTS_WEB_LadinBillQqueryManageMentList/web'
      let reqArgs = {
        ebOrderIds: ebOrderIds
      }
      if(ebOrderIds.length>0){
        downloadExcel(reqArgs,str,url,'ladingBill')
      }else{
        self.$coreMethods.message('warn',this.$t('message.unableToExport'))
      }
    },
    toStatushistory() {
      let self = this;
      let params = self.$refs.tableRef.getSelections();
      if (params.length === 0 || params.length > 1) {
        self.$coreMethods.message("warning", "请勾选一条记录");
      } else {
        this.$router.push({
          name: "StatusHistory",
          params: {
            orderNo: params[0].orderNo,
          },
        });
      }
    },
    toVGMEdit() {
      let self = this;
      let params = self.$refs.tableRef.getSelections();
      if (params.length === 0) {
        self.$coreMethods.message("warning", "请勾选记录");
      } else if (params.length > 1) {
        self.$coreMethods.message("warning", "请确认是否单选");
      } else {
        console.log(params);
        sessionStorage.setItem("ebOrderParams", JSON.stringify(params));
        sessionStorage.setItem("ebOrderType", "edit");
        self.$router.push({
          name: "VGMEdit",
          params: {
            ebOrderId: params[0].ebOrderId,
            type: "edit",
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-tabs__content {
  display: none;
}
</style>
